/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ReferralDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * Returns referral attributions visible to the caller. admin sees every referral platform-wide; coop_admin sees only referrals where the referred user is a farmer in a cooperative they admin (cooperatives.admin_user_id = caller). Each row pairs the referrer with the new (referred) user and the referred user's signup time. Ordered most-recent signup first.
 * @summary List referral attributions (who referred whom)
 */
export const referralsControllerList = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<ReferralDto[]>(
      {url: `/referrals`, method: 'GET', signal
    },
      );
    }
  



export const getReferralsControllerListQueryKey = () => {
    return [
    `/referrals`
    ] as const;
    }

    
export const getReferralsControllerListQueryOptions = <TData = Awaited<ReturnType<typeof referralsControllerList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralsControllerList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReferralsControllerListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof referralsControllerList>>> = ({ signal }) => referralsControllerList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof referralsControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ReferralsControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof referralsControllerList>>>
export type ReferralsControllerListQueryError = unknown


export function useReferralsControllerList<TData = Awaited<ReturnType<typeof referralsControllerList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralsControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof referralsControllerList>>,
          TError,
          Awaited<ReturnType<typeof referralsControllerList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useReferralsControllerList<TData = Awaited<ReturnType<typeof referralsControllerList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralsControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof referralsControllerList>>,
          TError,
          Awaited<ReturnType<typeof referralsControllerList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useReferralsControllerList<TData = Awaited<ReturnType<typeof referralsControllerList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralsControllerList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List referral attributions (who referred whom)
 */

export function useReferralsControllerList<TData = Awaited<ReturnType<typeof referralsControllerList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof referralsControllerList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getReferralsControllerListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




